import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QuoteStateModule } from '@nibtravel/shared/data-access/quote';
import { RadioGroupModule } from '@nibtravel/shared/ui/forms/radio-group';

import { TripSelectorComponent } from './qqc-trip-selector.component';

@NgModule({
  imports: [CommonModule, RadioGroupModule, QuoteStateModule],
  declarations: [TripSelectorComponent],
  exports: [TripSelectorComponent],
})
export class QqcTripSelectorModule {}
